import React, { Component, Fragment } from "react";

import * as Func from "../../../../../../helpers/functions";
import {
  DATE_TIME_FORMAT,
  ORDER,
  PATHS
} from "../../../../../../constants/Define";
import i18n from "../../../../../../constants/initLng";
import { getMomentDate } from "../../../../../../utils/commonUtils";
import {
  FormWrapperItem,
  ListComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import Span from "../../../../common/component/Span";
import * as HMS from "../../../../common/component/Index";
import {
  Skeleton,
  Modal,
  Menu,
  Icon,
  Dropdown,
  message,
  Input,
  Alert
} from "antd";
import Order, {
  OrderBundleSurchargeItem
} from "../../../../../../models/Order";
import moment from "moment";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import "./SurchargeInfo.less";

const OrderSurchargeItemKeys = Object.getOwnPropertyNames(
  new OrderBundleSurchargeItem()
);
class SurchargeInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleOrderItemTable: Func.getTitleTable(
        ["rowIndex", ...OrderSurchargeItemKeys, "action"],
        [],
        [
          "id",
          "rateCodes",
          "name",
          "paymentType",
          "paymentDate",
          "transactionId",
          "operaBookingCode",
          "orderItemType",
          "orderId",
          "itemVariantId",
          "orderCode",
          "transactionName",
          "transactionCode"
        ]
      ),
      modelOrderItem: OrderSurchargeItemKeys,
      componentTable: {
        rowIndex: {
          width: 100,
          align: "center",
          key: "rowIndex",
          render: (_, __, index) => index + 1
        },
        amount: {
          key: "amount",
          render: (text, record) =>
            Func.formatMoney(record.amount || "") + i18n.t("currencySymbol")
        },
        surchargeType: {
          key: "surchargeType",
          render: (text, record) =>
            text && i18n.t(`item.order.surchargeType.${text}`)
        },
        createdDate: {
          key: "createdDate",
          render: date => {
            return (
              date && getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE)
            );
          }
        },
        ftCode: {
          key: "ftCode",
          render: (text, record) => text
        },
        note: {
          key: "note",
          render: (text, record) => text
        },
        isDeleted: {
          key: "isDeleted",
          render: isDeleted => (
            <HMS.StatusComponent
              color={!isDeleted ? "green" : "gray"}
              label={
                !isDeleted
                  ? this.props.t("item.surcharge.status.active")
                  : this.props.t("item.surcharge.status.delete")
              }
            />
          )
        },
        createdBy: {
          key: "createdBy",
          render: (text, record) => text
        },
        action: {
          width: 100,
          align: "center",
          key: "action",
          fixed: "right",
          render: (text, record) => {
            return this.props.disableCreated ? null : !record.isDeleted && this.renderEditComponent(record);
          }
        }
      },
      ftCode: "",
      itemSelected: null
    };
  }

  onFTCodeChange = e => {
    const value = e?.target?.value ?? "";
    this.setState({ ftCode: value.trim() });
  };

  render() {
    const { surcharges, pagination, loading, orderId, t } = this.props;
    const {
      titleOrderItemTable,
      modelOrderItem,
      componentTable,
      itemSelected,
      ftCode
    } = this.state;

    return (
      <Wrapper className="bundle-order-surcharge-info-section col-md-12 mb-3">
        <FormWrapperItem classParent="p-0" classChildren="m-0 p-0">
          {!loading ? (
            <ListComponent
              scroll={{ x: 1800 }}
              classParent="m-0 p-0 col-md-12"
              marginTop={"0"}
              marginBottom={"0"}
              loading={{ spinning: loading, size: "large" }}
              rowKey={(record, k) => k}
              dataSource={Func.getDataSource(surcharges || [], modelOrderItem)}
              columns={Func.columnsTable({
                titleTable: titleOrderItemTable,
                component: componentTable,
                itemName: "bundleOrderSurcharge"
              })}
              onChange={this.props.onTableChange}
              pagination={{
                total: pagination.totalCount,
                totalPage: pagination.totalPage,
                defaultCurrent: pagination.pageIndex,
                defaultPageSize: pagination.pageSize
              }}
              componentTableList={{}}
              hideSettings={true}
            />
          ) : (
            <Skeleton active paragraph={{ row: 3 }} className="p-4" />
          )}
        </FormWrapperItem>
        <Modal
          title={t("item.bundleOrderSurcharge.modalSurchage.title")}
          visible={!!itemSelected}
          onOk={this.confirmRemove}
          onCancel={this.handleCloseModal}
          okText={t("action.confirm")}
        >
          {!!itemSelected && (
            <Fragment>
              <p>
                {`${t(
                  "item.bundleOrderSurcharge.modalSurchage.totalSurchargeCost"
                )}: `}
                <b>
                  {Func.formatMoney(itemSelected.amount || "") +
                    i18n.t("currencySymbol")}
                </b>
              </p>
              <HMS.FormWrapperInputComponent
                isRequired={true}
                isValidation={true}
                labelTitle={t(`item.bundleOrderSurcharge.ftCode`)}
              >
                <Input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  name="ftCode"
                  onChange={this.onFTCodeChange}
                  value={ftCode}
                />
              </HMS.FormWrapperInputComponent>
              <Alert
                message={t("item.bundleOrderSurcharge.modalSurchage.message")}
                type="info"
                showIcon
              />
            </Fragment>
          )}
        </Modal>
      </Wrapper>
    );
  }

  confirmRemove = () => {
    if (!this.state.ftCode) {
      return message.error("Vui lòng nhập FT Code!");
    }
    const { itemSelected } = this.state;
    itemSelected.ftCode = this.state.ftCode;
    this.props.removeSurcharge && this.props.removeSurcharge(itemSelected);
    this.handleCloseModal();
  };

  handleCloseModal = () => {
    this.setState({
      itemSelected: null,
      ftCode: ""
    });
  };

  renderEditComponent(item) {
    const { t } = this.props;
    const removeSurchargeDetail = () => {
      item.itemVariantId = item.itemVariantId;
      item.listType = this.props.listType;
      this.setState({
        itemSelected: item
      });
      // this.props.removeSurcharge && this.props.removeSurcharge(item)
    };

    // const onClickOpenDetail = () => {
    //     this.props.openModalDetail(item.itemVariantId, item.id, this.props.listType)
    // }

    return (
      <Fragment>
        <Dropdown
          overlay={
            <Menu className="action-menu">
              {/* <Menu.Item onClick={onClickOpenDetail}><Icon type="form" className="fs20 mr-1" /> {i18n.t(`action.edit`)}</Menu.Item> */}
              <Menu.Item onClick={removeSurchargeDetail}>
                <Icon type="delete" className="fs20 mr-1" />
                {i18n.t(`action.cancel`)}
              </Menu.Item>
            </Menu>
          }
        >
          <Icon type="more" className="fs20 cursorPointer" />
        </Dropdown>
      </Fragment>
    );
  }
}

export default withTranslation()(SurchargeInfo);
